/**
 * @type {{previewsContainerClass: string, clickableLinkClass: string, previewTemplateClass: string, formNameClass: string, formErrorsClass: string, init: jsMultiFileInput.init, initDropZone: jsMultiFileInput.initDropZone, resetFormErrors: jsMultiFileInput.resetFormErrors}}
 */
var jsMultiFileInput = {
    previewsContainerClass: '.js-dropzone-previews',
    clickableLinkClass: '.js-multiple-upload-file',
    previewTemplateClass: '.js-preview-template',
    formNameClass: '.js-multi-drop-files',
    formErrorsClass: '.js-form-error',
    hiddenInputClass: '.js-hidden-input-file',

    init: function () {
        jsMultiFileInput.initDropZone();
    },

    initDropZone: function () {
        if ($(jsMultiFileInput.formNameClass).length > 0) {
            Dropzone.autoDiscover = false;

            const attachLink = jsMultiFileInput.clickableLinkClass;
            const hasAttachmentArea = $(attachLink).length > 0;

            let options = {
                autoProcessQueue: false,
                uploadMultiple: true,
                parallelUploads: 100,
                maxFiles: 100,
            };

            if (hasAttachmentArea) {
                options = {
                    ...options,
                    paramName: $(jsMultiFileInput.hiddenInputClass).attr('name'),
                    previewsContainer: jsMultiFileInput.previewsContainerClass,
                    clickable: attachLink,
                    previewTemplate: document.querySelector(jsMultiFileInput.previewTemplateClass)?.innerHTML,
                };
            }

            $(jsMultiFileInput.formNameClass).dropzone({
                ...options,

                init: function () {
                    var $this = this;

                    // First change the button to actually tell Dropzone to process the queue.
                    var submitButton = this.element.querySelector('input[type=submit]');
                    submitButton.addEventListener('click', function (e) {
                        e.preventDefault();
                        e.stopPropagation();

                        $(this).prop('disabled', true);

                        if ($this.getQueuedFiles().length > 0) {
                            $this.processQueue();
                        } else {
                            // Dropzone requires a file, so we send an empty file.
                            var blob = new Blob();
                            blob.upload = { chunked: $this.defaultOptions.chunking };
                            $this.uploadFile(blob);
                        }
                    });

                    // Will be executed if the request has been successful.
                    this.on('successmultiple', function (files, response) {
                        jsMultiFileInput.resetFormErrors(submitButton);

                        // Reset the form.
                        $this.removeAllFiles(true);
                        $this.element.reset();

                        $('.js-alert').remove();
                        $('.c-frame').prepend(`
                            <div class="c-alert js-alert">
                              <div class="c-alert-box c-alert-box--success">
                                ${Translator.trans('message.submissionSuccess', {}, 'base')}
                                <span class="c-alert-box__close js-toggle" data-target=".js-alert">
                                  <i class="material-icons material-icons--sm">close</i>
                                </span>
                              </div>
                            </div>`
                        );
                    });

                    // Will be executed if an error has been found.
                    this.on('errormultiple', function (files, response) {
                        jsMultiFileInput.resetFormErrors(submitButton);

                        // Re-queue the files for upload.
                        $.each(files, function (key, file) {
                            file.status = Dropzone.QUEUED;
                        });

                        var formElement = $($this.element);
                        $.each(response, function (key, values) {
                            if ($.isArray(values)) {
                                $.each(values, function (k, value) {
                                    formElement
                                        .find('[name*="' + key + '"]')
                                        .after('<span class="c-alert-inline c-alert-inline--error js-form-error">' + value + '</span>');
                                });
                            }

                            formElement.find('[name*="' + key + '"]').addClass('has-error');
                            formElement.find('[for*="' + key + '"]').addClass('has-error');
                        });
                    });

                    // Create the remove button.
                    this.on('addedfile', function (file) {
                        var removeButton = Dropzone.createElement(
                            '<a href="#" class="c-button c-button--sm c-button--beta"><i class="material-icons material-icons--sm">delete</i></a>',
                        );

                        removeButton.addEventListener('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();

                            // Remove the file preview.
                            $this.removeFile(file);

                            // Remove an error message.
                            $('.js-dropzone-errors').find(jsMultiFileInput.formErrorsClass).remove();
                        });

                        file.previewElement.appendChild(removeButton);
                    });
                },
            });
        }
    },

    /**
     * @param submitButton
     */
    resetFormErrors: function (submitButton) {
        $(submitButton).prop('disabled', false);
        $(jsMultiFileInput.formErrorsClass).remove();
        $('.has-error').removeClass('has-error');
    },
};

$(document).ready(jsMultiFileInput.init);
